import {
  type TeamSpace,
  type UpdateTeamSpaceRoles,
} from "@prismicio/editor-fields"
import { Box } from "@prismicio/editor-ui"
import { type Dispatch, type SetStateAction, Suspense } from "react"

import { useRepositoryV2 } from "../../app/services/repository"
import { CustomRoles, CustomRolesSkeleton } from "./CustomRoles/CustomRoles"
import { CustomRolesLeadsCard } from "./CustomRoles/CustomRolesLeadsCard"

interface TeamSpacesCustomRolesTabProps {
  teamSpace?: TeamSpace
  roleUpdates: UpdateTeamSpaceRoles
  setRoleUpdates: Dispatch<SetStateAction<UpdateTeamSpaceRoles>>
}

export function TeamSpacesCustomRolesTab(props: TeamSpacesCustomRolesTabProps) {
  const { teamSpace, roleUpdates, setRoleUpdates } = props

  const { data: repository } = useRepositoryV2()
  const areCustomRolesEnabled = repository?.quotas.customRolesEnabled

  return (
    <Box display="block" minHeight={0} height="100%" flexGrow={1}>
      {areCustomRolesEnabled ? (
        <Suspense fallback={<CustomRolesSkeleton />}>
          <CustomRoles
            teamSpace={teamSpace}
            roleUpdates={roleUpdates}
            setRoleUpdates={setRoleUpdates}
          />
        </Suspense>
      ) : (
        <CustomRolesLeadsCard />
      )}
    </Box>
  )
}
